export const RECENT_SEARCHES_KEY = 'bettermode:recent-searches'
export const MAX_RECENT_SEARCHES = 5
